export default __webpack_public_path__ + "static/media/align-left.4abaa727.svg";